<template>
  <!-- Grid do Produtos -->
  <div class="requests">
    <div class="header-filter form-inline mb-3">
      <h4 class="mr-5">Pedidos de Venda</h4>
      <button class="btn btn-outline-primary" type="button" @click="showMenuFilter()">
        <i class="fas fa-angle-double-down" v-if="!showMenu"></i>
        <i class="fas fa-angle-double-up" v-else></i>
        Filtrar pedidos
      </button>
    </div>
    <div class="menu-filter" v-show="showMenu">
      <div class="inputs p-3">
        <div class="row">
          <div class="form-group col-8">
            <label>Data Inicial</label>
            <input id="input-date-start" type="search" class="form-control" placeholder="dd/mm/aaaa">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <label>Data Final</label>
            <input id="input-date-end" type="search" class="form-control" placeholder="dd/mm/aaaa">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label>Situação</label>
            <select id="select-situation" class="form-control">
              <option value="Aberto">Aberto</option>
              <option value="Fechado">Fechado</option>
              <option value="Todos" selected>Todos</option>
            </select>
          </div>
        </div>
      </div>
      <div class="buttons modal-footer mb-n2">
        <button class="btn btn-secondary mr-2" type="button" @click="showMenuFilter()">Cancelar</button>
        <button class="btn btn-primary" type="button" @click="filterRequests()">Filtrar</button>
      </div>
    </div>
    <div class="form-group form">
      <div class="row">
        <table class="table">
          <thead class="thead">
            <tr>
              <th scope="col" class="text-right">Data</th>
              <th scope="col">Nome</th>
              <th scope="col" class="text-right">Total</th>
              <th scope="col">Situação</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(request, index) in requests" :key="index">
              <td class="text-right">{{ request.date.slice(8, 10) }}/{{ request.date.slice(5, 7)}}/{{ request.date.slice(0, 4)}}</td>
              <td>{{ request.nameUser }}</td>
              <td class="text-right"><span v-money-format="request.total" /></td>
              <td>{{ request.situation }}</td>
              <div class="btn-group">
                <td>
                  <button class="btn btn-outline-secondary" @click="previewRequest(request)">
                    <i class="fas fa-file-alt"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn btn-outline-danger" @click="deleteRequest(request.id)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn btn-outline-warning" @click="updateRequest(request.id, request.situation)">
                    <i class="fas fa-truck"></i>
                  </button>
                </td>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <RequestPreview v-if="showPreview" :propsRequest=request @closePreview="previewRequest"/>
  </div>
</template>

<script>
import RequestPreview from './RequestPreview.vue'
import date from 'date-and-time'

export default {
  name: 'Requests',
  data: () => ({
    showMenu: false,
    showPreview: false,
    requests: [],
    request: {}
  }),
  components: {
    RequestPreview
  },
  methods: {
    showMenuFilter () {
      this.showMenu = !this.showMenu

      if (this.showMenu) {
        const inputDateStart = document.getElementById('input-date-start')
        const inputDateEnd = document.getElementById('input-date-end')

        inputDateStart.value = date.format(new Date(), 'DD/MM/YYYY')
        inputDateEnd.value = date.format(new Date(), 'DD/MM/YYYY')
      }
    },
    getRequests () {
      this.$firebase.database().ref('requests').orderByChild('situation').equalTo('Aberto')
        .on('value', (data) => {
          const values = data.val()
          if (values !== null) {
            this.requests = Object.keys(values).map((items) => values[items])
          } else this.requests = []
        })
    },
    filterRequests () {
      let inputDateStart = document.getElementById('input-date-start').value
      let inputDateEnd = document.getElementById('input-date-end').value
      const selectSituation = document.getElementById('select-situation')

      inputDateStart = `${inputDateStart.slice(6, 10)}/${inputDateStart.slice(3, 5)}/${inputDateStart.slice(0, 2)}`
      inputDateEnd = `${inputDateEnd.slice(6, 10)}/${inputDateEnd.slice(3, 5)}/${inputDateEnd.slice(0, 2)}`

      this.$firebase.database().ref('requests').orderByChild('date').startAt(inputDateStart).endAt(inputDateEnd)
        .on('value', (data) => {
          const values = data.val()
          if (values !== null) {
            if (selectSituation.value !== 'Todos') {
              const arrayFilter = Object.keys(values).map((items) => values[items])
              this.requests = arrayFilter.filter((i) => i.situation === selectSituation.value)
            } else {
              this.requests = Object.keys(values).map((items) => values[items])
            }
          } else this.requests = []
        })
      this.showMenuFilter()
    },
    deleteRequest (id) {
      const resultado = confirm('Deseja excluir o pedido de venda?')
      if (resultado === true) {
        this.$firebase.database().ref(`requests/${id}`)
          .remove().then(() => {
            this.$root.$emit('Notification::show', {
              message: 'Pedido de venda removido com sucesso.',
              type: 'success'
            })
          }).catch(() => {
            this.$root.$emit('Notification::show', {
              message: 'Não foi possivel exlcuir o pedido de venda, tente novamente.',
              type: 'danger'
            })
          })
      }
    },
    updateRequest (id, situation) {
      if (situation === 'Aberto') {
        const resultado = confirm('Deseja fechar o pedido de venda?')
        if (resultado === true) {
          this.$firebase.database().ref(`requests/${id}`)
            .update({
              situation: 'Fechado'
            }).then(() => {
              this.$root.$emit('Notification::show', {
                message: 'Pedido de venda fechado com sucesso.',
                type: 'success'
              })
            }).catch(() => {
              this.$root.$emit('Notification::show', {
                message: 'Não foi possivel fechar o pedido de venda, tente novamente.',
                type: 'danger'
              })
            })
        }
      }
    },
    previewRequest (object) {
      this.showPreview = !this.showPreview
      this.request = object
    },
    clearCounterRequests () {
      this.Ref = this.$firebase.database().ref('parameters')
        .update({
          counter: 0
        })
    }
  },
  created () {
    this.getRequests()
    this.clearCounterRequests()
  }
}
</script>

<style lang="scss" scoped>
.requests {
  padding: 40px 60px;
  height: 100%;
  .header-filter {
      display: flex;
      justify-content: space-between;
  }
  .header-filter-close {
  display: none !important;
}
  .menu-filter {
    position: absolute;
    height: 380px;
    width: 250px;
    box-sizing: border-box;
    right: 57px;
    top: 162px;
    transition: .4s;
    z-index: 1000;
    background-color: #fafafa;
    box-shadow: 2px 2px 8px 3px rgba(73, 73, 73, 0.3);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    #input-date-start, #input-date-end {
      width: 140px;
    }
  }
}
.form-close {
  display: none !important;
}
</style>
